export default __webpack_public_path__ + "static/media/lock-icon.e4725849.svg";